exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button-box {\n  padding: 10px 20px;\n}\n.button-box .el-button {\n  float: right;\n}", ""]);

// exports
